<header class="mat-body-1">
  {{ title }}
</header>
<p class="mat-body-2">
  {{ subTitle }}
</p>
<div class="textarea-with-action">
  <mat-form-field>
    <textarea
      matInput
      [placeholder]="placeholder"
      [formControl]="control"
      [maxlength]="maxLength"
    ></textarea>
  </mat-form-field>
  <div class="actions mt-2">
    <small class="mat-caption">
      {{ maxLength - control.value.length }}&nbsp;
      <ng-container i18n="@@TextAreaAutosave.CharactersRemaining">
        characters remaining
      </ng-container>
    </small>

    <div class="save-state saving rounded-pill" *ngIf="loading; else ELSE">
      <small i18n="@@TextAreaAutosave.Feedback.Saving">Saving...</small>
    </div>

    <ng-template #ELSE>
      <div class="save-state saved rounded-pill" *ngIf="this.control.touched">
        <small i18n="@@TextAreaAutosave.Feedback.Saved">Saved</small>
      </div>
    </ng-template>
  </div>
</div>
